<template>
  <div class="text-center">
    <v-dialog
      v-model="AddnKeysShow"
      persistent
      max-width="550"
    >
      <v-card>
        <v-card-title class="headline d-flex justify-space-between px-5 py-3 v-modal-header"
          ><h5 class="text-h6"> {{$t('addnKeys.addNegKeywords')}}</h5>
          <v-icon @click="close()">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="pa-3">
          <v-card
            outlined
            class="pa-2 rounded-0 border-x-0" style="border:none"
            height="58"
          >
          
            <div class="addkeword">
              <div class="d-flex">
                <v-text-field
                  class="rounded-0 rounded-l-lg no-field-details mb-0"
                  v-model="keywordInput"
                  placeholder="Add one or add multiple comma separated"
                  required
                  outlined
                  dense
                ></v-text-field>
                <v-btn
                  @click="addKeyword()"
                  width="36"
                  height="40"
                  class="rounded-0 rounded-r-lg border-l-0 grey--text"
                  depressed
                  outlined
                  ><span class="secondary--text"
                    >{{$t('addnKeys.add')}}</span
                  ></v-btn
                >
              </div>
            </div>
          </v-card>
          <div class="keword-lists pa-2 v-max-height-300">
            <v-row
              v-for="keyword in keywords"
              :key="keyword.text"
            >
              <v-col lg="4" md="5" sm="5" class="py-0 pt-3 pl-0 word-nowrap">
                <v-btn
                  @click="deleteKeyword(keyword.text)"
                  width="32"
                  depressed
                  x-small
                  fab
                  text
                  color="error"
                  ><v-icon small
                    >mdi-delete-outline</v-icon
                  ></v-btn
                >
                {{ keyword.text }}
              </v-col>
              <v-col lg="8" md="7" sm="7" class="py-0 pt-3 pr-0">
                <v-select
                  v-model="keyword.matchType"
                  class="no-field-details"
                  :items="matchTypes"
                  label="Match Type"
                  required
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </div>
          <div class="pagination pa-2">
            <span class="pagination-total secondary--text"
              >{{$t('addnKeys.total')}} {{ keywords.length }}</span
            >
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="emitAddnKeysCancelClicked"
          >
            {{$t('addnKeys.cancel')}}
          </v-btn>
          <v-btn
            color="success"
            text
            @click="emitAddnKeysOkClicked"
          >
            {{$t('addnKeys.save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name : 'DecisionAlert',
  data() {
    return {
      emitMsgOk : 'clicked Ok',
      emitMsgCancel : 'clicked Cancel',
      nKeys: [],
      AddnKeysShow: false,
      keywordInput: '',
      keywords: [],
      matchTypes: ['EXACT', 'BROAD'],
    }
  },
  props:{
    AddnKeysData : {
      type: Object,
      default() {
        return;
      },
    },
  },
  watch: {
    AddnKeysData: function (data) {
      //console.log(data);
      this.AddnKeysShow = true;
    },
  },
  methods: {
   close() {
     //console.log('close');
      this.AddnKeysShow = false;
      this.keywordInput = '';
      this.keywords = [];
    },

    emitAddnKeysOkClicked() {
      //console.log('emitAddnKeysOkClicked');
      this.$emit('emitAddnKeysOkClicked', this.keywords);
      this.close();
    },

    emitAddnKeysCancelClicked() {
      //console.log('emitAddnKeysCancelClicked');
      this.$emit('emitAddnKeysCancelClicked', this.emitMsgCancel);
      this.close();
    },

    addKeyword() {
      const keys = this.keywordInput.split(',');
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index];
        //console.log(element);
        if (
          element &&
          !this.keywords.find((kw) => kw.text === element)
        ) {
          this.keywords.push({
            text: element,
            matchType: 'EXACT',
          });
        }
        this.keywordInput = '';
      }
    },

    deleteKeyword(keyword) {
      this.keywords = this.keywords.filter((kw) => kw.text !== keyword);
    },
  }
})
</script>

